export const lockScroll = (): number => {
  const scrollTop = window.visualViewport?.pageTop || document.documentElement.scrollTop || 0

  document.body.setAttribute('modalOpen', 'true')
  document.body.style.top = `-${scrollTop}px`

  return scrollTop
}

export const unlockScroll = (scrollTop: number): void => {
  document.body.setAttribute('modalOpen', 'false')
  document.documentElement.scrollTop = scrollTop
  document.body.style.top = 'unset'
}
